
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/ml",
      function () {
        return require("private-next-pages/features/ml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/ml"])
      });
    }
  